import { AxiosInstance } from 'axios';

// From impersonationToken, not impersonation: the latter imports the vault-api client,
// which would close an import cycle back through this interceptor.
import { recoverFromExpiredToken } from '../../../utils/impersonationToken';

export const redirectToLoginOnUnauthorized = (axiosInstance: AxiosInstance) => {
  // The app fires several requests at once, so one dead token means a burst of 401s.
  // Only the first may act: recovery is one-way, and a later handler would see the
  // already-restored admin token, read it as "not impersonating", and redirect to SSO
  // over the top of the reload the first one asked for.
  let handled = false;

  axiosInstance.interceptors.response.use((response) => response, (error) => {
    if (error.response && error.response.status === 401 && !handled) {
      handled = true;

      // A 401 means the active token is dead. If that was an impersonation token that
      // ran out its 30 minutes, the admin gets their own session back rather than a trip
      // through SSO; either way this clears the stashed admin token, which would
      // otherwise outlive the session it belonged to.
      if (recoverFromExpiredToken()) {
        window.location.reload();
      } else {
        window.location.replace(process.env.REACT_APP_SSO_LOGIN_URL);
      }
    }
    return Promise.reject(error);
  });
};
